<script setup>
import { computed } from 'vue'
import { defineProps, defineEmits } from 'vue'

const props = defineProps({
    options: {
        type: Array,
        required: true,
        default: () => [],
    },
    modelValue: {
        type: String,
        required: true,
    },
})
const emit = defineEmits(['update:modelValue'])

const selectedValue = computed({
    get: () => props.modelValue,
    set: (value) => emit('update:modelValue', value),
})
</script>

<template>
    <div class="flex items-center gap-4">
        <div class="flex items-center gap-2 cursor-pointer" v-for="option in options" :key="option.value" @click="selectedValue = option.value">
            <div class="relative w-5 h-5">
                <!-- active State -->
                <svg v-if="selectedValue === option.value" width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.5" y="2.5" width="19" height="19" rx="9.5" fill="#F9F5FF"/>
                    <rect x="0.5" y="2.5" width="19" height="19" rx="9.5" stroke="#7F56D9"/>
                    <circle cx="10" cy="12" r="4" fill="#7F56D9"/>
                </svg>
                <!-- inactive State -->
                <svg v-else width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" fill="white"/>
                    <rect x="0.5" y="0.5" width="19" height="19" rx="9.5" stroke="#D0D5DD"/>
                </svg>
                <!-- hidden native radio for accessibility -->
                <input 
                    type="radio" 
                    :id="option.value" 
                    :value="option.value" 
                    v-model="selectedValue"
                    class="absolute opacity-0 w-full h-full cursor-pointer"
                />
            </div>
            <label :for="option.value" class="cursor-pointer text-[#344054] text-sm">{{ option.label }}</label>
        </div>
    </div>
</template>

<style scoped>
/* Add any additional styling here if needed */
</style>
